/**
 * The live view of the fleet (roadmap U1): every running agent across every connected
 * workbench and node, who and what it is working on, on which project, task and machine.
 *
 *   GET /fleet/v1/live     the signed-in person's workbenches (administrators and operators: all of them)
 *                          asked `agents.activity` at once, with a short deadline; the answer says which
 *                          machines answered and lists their agents
 *
 * Stopping an agent, cancelling its turn and reading its transcript go through the machine's own
 * Control API over the relay (`POST /relay/v1/devices/:id/rpc`: sessions.stop, sessions.cancel,
 * sessions.transcript), so the workbench checks scope and policy and audits the call.
 *
 * Words for people: agent, team, project, task, machine; working, waiting on you, idle.
 */
/** Plain words for an agent's state, and the mark it takes. */
export function liveStatusText(status) {
    switch (status) {
        case "thinking":
            return { text: "Thinking", mark: "working" };
        case "tool_calling":
            return { text: "Using a tool", mark: "working" };
        case "waiting_approval":
            return { text: "Waiting on you", mark: "medium" };
        case "starting":
            return { text: "Starting", mark: "working" };
        case "error":
            return { text: "Error", mark: "error" };
        case "idle":
            return { text: "Idle", mark: "idle" };
        default:
            return { text: status.replace(/_/g, " "), mark: "idle" };
    }
}
export const LIVE_WORKING = ["starting", "thinking", "tool_calling"];
//# sourceMappingURL=live.js.map